import React from 'react';
import './CoverDisplay.css';
import SoldIcon from '../../assets/sold.png';
import CrackedIcon from '../../assets/cracked.png';

const ImagesPageGradeLink = ({ image }) => {
  let imageCoverData;

  try {
    imageCoverData = JSON.parse(image.cover_image);
  } catch (e) {
    imageCoverData = [];
  }

  const modifiedCoverImageData = imageCoverData.map((item) => {
    const modifiedCoverImage = { ...item };

    if (modifiedCoverImage.name.includes('/home/u825454141/domains/alientrader.net/public_html/')) {
      modifiedCoverImage.name = modifiedCoverImage.name.replace(
        '/home/u825454141/domains/alientrader.net/public_html/',
        'https://api.alientrader.cards/'
      );
    } else {
      modifiedCoverImage.name = 'https://api.alientrader.cards/' + modifiedCoverImage.name;
    }

    if (modifiedCoverImage.thumbnail) {
      if (modifiedCoverImage.thumbnail.includes('/home/u825454141/domains/alientrader.net/public_html/')) {
        modifiedCoverImage.thumbnail = modifiedCoverImage.thumbnail.replace(
          '/home/u825454141/domains/alientrader.net/public_html/',
          'https://api.alientrader.cards/'
        );
      } else {
        modifiedCoverImage.thumbnail = 'https://api.alientrader.cards/' + modifiedCoverImage.thumbnail;
      }
    }

    return modifiedCoverImage;
  });

  const gradeLink = image.card_grade_link || `/card/${image.card_id}`;

  return (
    <div>
      {modifiedCoverImageData.map((img, index) => (
        <a
          key={index}
          href={gradeLink}
          target="_blank"
          rel="noreferrer"
          data-lightbox="cover"
          data-title={img.usrName}
        >
          <img src={img.thumbnail} alt={img.usrName} className="imagesPageDisplay" />
          {image.card_owner === 'Sold' ? (
            <div className="subCardWallIcons">
              <img src={SoldIcon} alt="Sold" height="70" className="cardWallSoldIcon" />
            </div>
          ) : null}
          {image.card_owner === 'Cracked' ? (
            <div className="subCardWallIcons">
              <img src={CrackedIcon} alt="Cracked" height="70" className="cardWallSoldIcon" />
            </div>
          ) : null}
        </a>
      ))}
      <div className="subCardWallGrades">
        {image.card_grade_number}
      </div>
    </div>
  );
};

export default ImagesPageGradeLink;
